"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImgPreviewMainImage = void 0;
const React = require("react");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const imgPreviewStyles = require("../../styles.scss");
const ImgBlock_1 = require("../../../ImgBlock");
const css = (0, cssComposer_1.default)(imgPreviewStyles, "imgPreview");
const ImgPreviewMainImage = ({ imageUrl }) => React.createElement(ImgBlock_1.ImgBlock, { src: imageUrl, className: css("mainImage_img") });
exports.ImgPreviewMainImage = ImgPreviewMainImage;
//# sourceMappingURL=index.js.map